const e = {
  extends: "MegaMillions",
  logo: !0
};
export {
  e as default
};
